function initAccordion() {
  const section = document.getElementById('shopify-section-sections--28477728522565__ls_heading_text_jqWGQX');
  if (!section) return;
  if (section.querySelector('button')) return;

  const btn = document.createElement('button');
  btn.textContent = 'MORE INFO +';
  btn.style.cssText = 'display:block; width:100%; text-align:center; background:none; border:none; cursor:pointer; padding: 8px 0; font-size: 0.85em; letter-spacing: 0.1em;';

  const lastHeading = Array.from(section.querySelectorAll('h2')).pop();
  if (lastHeading) {
    lastHeading.parentNode.insertAdjacentElement('afterend', btn);
  } else {
    section.appendChild(btn);
  }

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = section.classList.toggle('is-open');
    btn.textContent = isOpen ? 'CLOSE −' : 'MORE INFO +';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(initAccordion, 500));
} else {
  setTimeout(initAccordion, 500);
}